define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/reflection/reflectionConstants",
	"csi/session",
	"csi/state/rootStore",
	"csi/utility/routerUtility",
	"csi/widget/MessageDialog",
	"csi/xml",
	"lodash",
], function(declare, locale, reflectionConstants, session, {featureTogglesStore}, routerUtility, MessageDialog, xml, _) {

	const {
		LOCATION_URL,
		LOCATION_SECTION,
		LOCATION_SECTION_ITEM,
		LOCATION_TYPE,
		setLocationHash,
	} = routerUtility;

	return declare(null, {
		isAsync: null,

		onStart: function() {
			this.isAsync = featureTogglesStore.ENABLE_ASYNC_STYLE_COPY && (!this.m_idAttrParent || this.m_idAttrParent == "Hierarchy");
		},

		/**
		 * Flush changes to prevent locking/timeout issue due to uniqueness check in validation rules, and in doing so,
		 * ensure that if there is a validation failure that the copied node(s) are deleted when an error
		 */
		_toWriterValidateNode: function() {
			var w = this.m_writer;

			w.flushChanges();

			if(!this.isAsync) {
				_.each(this._getMoveFromUrls(), function(url) {
					w.callMethod("SiteAdmin", "ValidateAndDeleteIfFailed").addParameter(xml.PROP_URL, xml.ATTR_REF, url);
				});
			}
		},

		preloadSourceNodes: function() {
			// summary: preload nodes for the copy operation
			//TODO: use the reflection model to discover paths instead of hard-coding them
			var urlSource = xml.nodeGetURL(this.m_nodeSource);
			var cn = this.m_writer.changeList([urlSource]);

			cn.dependencyPath("Child:Attributes");
			cn.dependencyPath("Child:ProductColors");
			cn.dependencyPath("Child:ProductSizes");
			cn.dependencyPath("Child:Images");
			cn.dependencyPath("Child:Spec");
			cn.dependencyPath("Child:DataSheets/Child:CanvasImages");
			cn.dependencyPath("Child:DataSheets/Child:Revisions/Child:Pages/Child:Comments");
			cn.dependencyPath("Child:DataSheets/Child:Revisions/Child:Pages/Child:SVG");
			cn.dependencyPath("Child:DataSheets/Child:Revisions/Child:Items/Child:Actual/Child:Attributes");
			cn.dependencyPath("Child:DataSheets/Child:Revisions/Child:Items/Child:Actual/Child:ProductSourcing");
			cn.dependencyPath("Child:DataSheets/Child:Revisions/Child:Items/Child:Actual/Child:Spec");
			cn.dependencyPath("Child:DataSheets/Child:Revisions/Child:Items/Child:CommentRow");
			cn.dependencyPath("Child:DataSheets/Child:Revisions/Child:Items/Child:ReviewData/Child:ReviewSize");
			cn.dependencyPath("Child:IssueLog/Child:Issues");
			cn.dependencyPath("Child:ProductSourcing");
			cn.dependencyPath("Child:ProductSourcing/Child:ProductSources/Child:SupplierItems/Child:Revisions/Child:DutyRates");
			cn.dependencyPath("Child:DocumentsAndComments/Child:Documents/Child:Revisions/Child:Images");
			cn.dependencyPath("Child:DocumentsAndComments/Child:Comments");
		},

		toWriterRequest: function(/*FormData?*/fd) {
			// summary: handle request for second page
			var fd = this.getFormData();

			// go through all the fields. For any fields that have expressions that are not over-ridden, set the m_bUsed flag
			// so the values don't get passed to the server. The server should evaluate the expression.
			fd.getFields().forEach((field) => {
				if (field.hasExpression() && !field.bDisableExpressionEvaluation && field.isDefaultValue()) {
					field.m_bUsed = true;
				}
			});

			var call = this.inherited(arguments);

			const colorways = fd.getFieldValue("ProductColors", true);

			if (colorways && colorways.length) {
				call.addParameter("VOPT.SelectedURLs", xml.ATTR_REFLIST, colorways);
			}

			if(this.isAsync) {
				call.setModuleOperation("Apparel", "CollectionAsyncNewFromStyle");
				call.addParameter("CopyOptions", xml.ATTR_REF, fd.getFieldValue("CopyTemplates", true));
				if (_.isEmpty(this._sourcesToCheck)) {
					// popup dialog to route to queues and services page
					new MessageDialog({
						buttons: [MessageDialog.BUTTON_CHECK_PROGRESS + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_OK],
						materialIcon: MessageDialog.ICON_INFO,
						message: locale.resource("NewFromStyle_Async_Popup_Message"),
						title: locale.resource("NewFromStyle_Async_Popup_Title"),
						onResponse: (key, params) => {
							if (key == MessageDialog.BUTTON_CHECK_PROGRESS) {
								// redirect to queues and services page
								let locationParams = session.getLocationParams(null);
								locationParams[LOCATION_URL] = reflectionConstants.URL_DATA_SETUP;
								locationParams[LOCATION_SECTION] = "DataSetupServices";
								locationParams[LOCATION_SECTION_ITEM] = "StyleCopyJobs";
								locationParams[LOCATION_TYPE] = "_CS_DataSetup";
								setLocationHash(session.getLocation(null, locationParams));
								this.closeActionDialog();
							}
						}
					}).show();
				}
			} else {
				// disable attribute expressions as needed
				var cn = this.m_writer.changeNode(this.m_urlNode);
				fd.getFields().forEach((field) => {
					if (field.hasExpression() && (field.bDisableExpressionEvaluation || !field.isDefaultValue()) && !field.m_bUsed) {
						// field either using source value, attribute being copied had expression disabled, or expression overridden in form
						var id = field.m_id;
						var rca = field.m_rca;

						if (rca.isOneTimeExp) {
							cn.changeAttributeExp(id, "");
							cn.changeAttributeFlag(id, xml.ATTR_FLAG_EVAL_EXPRESSION | xml.ATTR_FLAG_ONE_TIME_EXPRESSION, false, true);
							cn.changeAttribute(id, field.getType(), field.getValue());
						} else {
							cn.disableAttributeExp(id);
						}
					}
				});
			}

			return call;
		}
	});
});
